var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.16354L7.01647 8L9.89015e-08 1.1313L1.15564 1.12289e-06L7.01639 5.73732L12.8443 0.0321653L14 1.16354Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrow);
export default __webpack_public_path__ + "static/media/accordion-arrow.8ab6655c.svg";
export { ForwardRef as ReactComponent };